<template>
    <div class="dialog-overlay" v-if="visible">
      <div class="dialog" :style="{ width: width }">
        <div class="dialog-header">
          <slot name="header">
            <span class="dialog-title">{{ title }}</span>
          </slot>
          <button class="close-button" @click="closeDialog">
            <img src="./images/icon-close.png" class="close-button-icon">
          </button>
        </div>
        <div class="dialog-body">
          <slot></slot>
        </div>
        <div v-if="!hideFooter" class="dialog-footer">
          <slot name="footer">
            <button class="cancel-button" @click="handleCancel">{{ cancelBtnText }}</button>
            <button class="confirm-button" @click="handleConfirm">{{ confirmBtnText }}</button>
          </slot>
        </div>
      </div>
    </div>
  </template>
  
  <script>

  export default {
    name: 'MallDialog',
    props: {
      title: {
        type: String,
        default: '标题'
      },
      visible: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '6.42rem'
      },
      cancelBtnText: {
        type: String,
        default: '取消'
      },
      confirmBtnText: {
        type: String,
        default: '确定'
      },
      confirm: {
        type: Function,
        default: () => {}
      },
      hideFooter: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeDialog() {
        this.$emit('update:visible', false);
      },
      handleCancel() {
        this.closeDialog();
        this.$emit('cancel', false);
      },
      handleConfirm() {
        const res = this.confirm();
        if (res !== false) {
          this.closeDialog();
        }
      },
    }
  };
  </script>
  
  <style scoped>
  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog {
    display: flex;
    flex-direction: column;
    background: #f9e1a3;
    border-radius: 50px;
    box-shadow: 0px 1px 3px 0px rgba(103,27,6,0.23), 0px -1px 1px 0px rgba(217,138,67,0.80) inset;
  }

  .dialog-header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 68px;
    background: #facf5d;
    border-radius: 50px 50px 0px 0px;
    box-shadow: 0px 1px 3px 0px rgba(103,27,6,0.23), 0px -1px 1px 0px rgba(217,138,67,0.80) inset; 
  }
  .dialog-title {
    padding: 8px 46px;
    background: #e9af43;
    border-radius: 24px;
    box-shadow: 0px 1px 0px 0px rgba(255,239,175,0.43), 0px 0px 3.48px 0.52px rgba(205,87,51,0.39) inset; 
    font-size: 28px;
    line-height: 1;
    font-weight: bold;
    color: #fff;
  }
  .close-button {
    position: absolute;
    right: 0;
    background: none;
    border: none;
    padding: 0 20px;
    cursor: pointer;
  }
  .close-button-icon {
    display: block;
    width: 46px;
    height: 46px;
  }

  .dialog-body {
    flex: 1;
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 36px;
    height: 88px;
    background: #fad981;
    border-radius: 0px 0px 50px 50px;
  }
  .confirm-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 53px;
    background: #ffe952;
    border: none;
    border-radius: 25px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ffbe31 inset; 
    font-size: 24px;
    font-weight: bold;
    color: #DD7146;
  }
  .cancel-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 53px;
    background: #fff9ea;
    border: none;
    border-radius: 25px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset;
    font-size: 24px;
    font-weight: bold;
    color: #90CA81;
  }
  </style>